<!-- eslint-disable -->
<template>

    <div>

        <b-alert
                show
                variant="light"
                class="alert alert-custom alert-white alert-shadow fade show gutter-b"
        >
            <div class="alert-icon">
            <span class="svg-icon svg-icon-lg">
              <inline-svg src="media/svg/icons/Tools/Compass.svg" />
            </span>
            </div>
            <div class="alert-text">
                Атрибуты могут быть назначены товарам и вариациям
            </div>
        </b-alert>

        <div class="row">
            <div class="col-md-12">
                <div class="card card-custom gutter-b">
                    <div class="card-header border-0">
                        <h3 class="card-title font-weight-bolder text-dark">Добавить атрибут</h3>
                        <div class="card-toolbar">
                        </div>
                    </div>

                    <div class="card-body">
                        <div v-if="load" class="text-center mb-10">
                            <b-spinner variant="primary" label="Text Centered"></b-spinner>
                        </div>

                        <div v-else >

                            <b-form-group class="mt-5"
                                          description="Введите название атрибута"
                                          label="Заголовок:"
                            >
                                <b-form-input
                                        v-model.trim="name"
                                        :class="{'is-invalid': errors.name}"
                                        required
                                ></b-form-input>
                                <div v-if="errors.name" class="invalid-feedback">{{errors.name[0]}}</div>
                            </b-form-group>

                            <b-form-group class=" mb-4"
                                          description="Выберите вид опций для вариативных товаров"
                                          label="Тип опций"
                            >
                                <b-form-select v-model="type" :class="{'is-invalid': errors.type}">

                                    <option value="default">По умолчанию</option>
                                    <option value="color">Цвет</option>


                                </b-form-select>
                                <div v-if="errors.type" class="invalid-feedback">{{errors.type[0]}}</div>
                            </b-form-group>

                            <b-button @click="addAttribute" ref="add_attribute" type="submit" variant="primary">Создать</b-button>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

    import { mapGetters } from "vuex";
    import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
    import {SET_ALERT} from "@/core/services/store/alert.module";
    import {ADD_ATTRIBUTE} from "@/core/services/store/attributes.module";
    export default {
        name: "AddAttribute",

        mounted() {
            this.$store.dispatch(SET_BREADCRUMB, [
                { title: "Атрибуты", route: "/attributes" },
                { title: "Добавить атрибут" }
            ]);
        },

        computed: {
            ...mapGetters({
                errors: 'errorsAttribute',
            }),
        },

        data() {
            return {
                name:'',
                type: 'default',
                load: false,
            }
        },

        methods:{
            addAttribute(){
                const submitButton = this.$refs["add_attribute"];
                submitButton.classList.add("spinner", "spinner-light", "spinner-right");


                const attribute = {
                    'name': this.name,
                    'type': this.type,
                };

                this.$store.dispatch(ADD_ATTRIBUTE, attribute)
                    .then((data) => {
                        this.showAlert('Атрибут успешно добавлен', 'success');
                        this.$router.push({ name: 'EditAttribute', params: {id: data.newattribute.id}});
                    })
                    .catch((response) => {
                        if (response.status === 422){
                            this.showAlert('Заполните все поля', 'danger', 'toast');
                        } else {
                            this.showAlert('Ошибка, попробуйте позже', 'danger', 'toast');
                        }
                    })
                    .finally(() => {
                        submitButton.classList.remove("spinner", "spinner-light", "spinner-right")
                    });
            },

            showAlert(text, variant, type) {
                this.$store.commit(SET_ALERT, {text, variant, type});
            },
        }
    }
</script>

<style scoped>

</style>